<template src="./AlertWarningComponent.html"></template>
<script>

import IconWarning from "@/components/icons/IconWarning.vue";

export default {
  name: 'AlertWarningComponent',
  components: {
    IconWarning
  },
  props: {
    label: {
      type: String,
      required: false,
      default: () => ''
    },
  },
  emits: [],
  setup() {
    return {
    }
  },
}
</script>
<style lang="scss">
.icon {
  width: 20px;
}
</style>
